import {Component, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-hw-catalog',
  templateUrl: './hw-catalog.component.html',
  styleUrls: ['./hw-catalog.component.scss']
})
export class HwCatalogComponent implements OnInit {

  public navState: any;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras.state) {
      this.navState = navigation?.previousNavigation?.extras.state;
    } else {
      this.navState = navigation?.extras.state;
    }
  }

  ngOnInit(): void {
    this.translocoService.selectTranslate('model.catalog').subscribe(() => {
      this.items = [
        {id: 'devices', label: this.translocoService.translate('model.devices')},
        {id: 'asset-representations', label: this.translocoService.translate('model.assetRepresentations')},
        {id: 'device-categories', label: this.translocoService.translate('model.deviceCategories')},
        {id: 'measurement-types', label: this.translocoService.translate('model.sensorTypes')},
        {id: 'property-types', label: this.translocoService.translate('model.propertyTypes')},
        {id: 'decoders', label: this.translocoService.translate('model.decoders')},
        {id: 'encoders', label: this.translocoService.translate('model.encoders')}
      ];

      this.items.forEach(item => {
        this.translocoService.selectTranslate(item.label).subscribe(value => {
          return item.label = value;
        });
      });

      if (this.navState && this.navState.showView) {
        this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
        this.activeItem = this.items[this.activeItemIndex];
      } else {
        this.activeItemIndex = 0;
        this.activeItem = this.items[this.activeItemIndex];
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

}
